export default {
  root: {
    padding: '16px 24px',
    backgroundColor: "black",
    color: "white",
    borderBottom: "3px solid #dc9a14"
  }
};
